export default __webpack_public_path__ + "static/media/009-jellyfish.935bc3c2.svg";